module.exports = {
      id: "bell-usage",
      viewBox: "0 0 20 22.857",
      url: "/" + "sprite-72169aba3aaebb7b19ede7951c92022d.svg#bell",
      toString: function () {
        return this.url;
      }
    }